interface PricingPlan {
  id: string;
  title: string;
  subtitle: string;
  price: number | string;
  features: string[];
  bulletPoints: string[];
  ctaText: string;
  ctaLink: string;
  buttonId: string;
  isHighlighted?: boolean;
  showCalculator?: boolean;
  showAudioPlayer?: boolean;
  packageType?: string;
  note?: string;
}

export const audioPlans: PricingPlan[] = [
  {
    id: "audio-basic",
    title: "Audio Basic",
    subtitle: "Wir retten deine Aufnahme",
    price: 60,
    features: [
      "Aufnahme versemmelt? Wir bügeln's glatt",
      "Wir entfernen Hall, Rauschen und Störgeräusche",
      "Hörbar bessere Ergebnisse",
    ],
    bulletPoints: [
      "Verbesserung der Sprachverständlichkeit",
      "Reduzierung von starken Hall",
      "Entfernung von Rauschen / Brummen",
      "Entfernung von Störgeräuschen",
      "Lautstärken Anpassungen",
      "Mischung & Mastering deiner Episode",
    ],
    ctaText: "Audio Basic Anfragen",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "classic-podcast",
    showAudioPlayer: true,
    note: "*Der Schnitt der Episode ist nicht Bestandteil dieses Angebots und wird bei Bedarf separat berechnet. (Preise in Netto)",
  },
  {
    id: "audio-pro",
    title: "Audio Pro",
    subtitle: "So klingt's am besten!",
    price: 0, // Will be set dynamically
    features: [
      "Dein Podcast professionell produziert",
      "Ideal für Remote-Podcasts",
      "Weil Qualität Vertrauen schafft",
    ],
    bulletPoints: [
      "Schnitt, Mischung, Sound-Design & Mastering",
      "Inkl. Feedbackschleife",
      "Social Assets (Audio Snippet)",
      "Reporting & Analyse vom Podcast",
      "Persönliche Betreuung (via Whatsapp, Mail & Telefon)",
      "1:1 Quartals/Feedbackgespräch",
      "Spare 50 % über unseren Podigee Hosting-Service",
    ],
    ctaText: "Audio Pro Anfragen",
    note: "*Preise in Netto",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "all-in-one-podcast",
    isHighlighted: true,
    showCalculator: true,
    packageType: "audio-pro",
  },
  {
    id: "audio-hosting",
    title: "Audio + Hosting",
    subtitle: "Alles drin. Alles aus einer Hand!",
    price: 0, // Will be set dynamically
    features: [
      "Für alle, die ihren Podcast-Workflow in professionelle Hände legen wollen!",
      "Wir übernehmen Produktion, Hosting und Veröffentlichung",
      "Spare Zeit und Nerven",
    ],
    bulletPoints: [
      "Schnitt, Mischung, Sound-Design & Mastering",
      "Inkl. Feedbackschleife",
      "Social Assets pro Episode (Audio Snippet)",
      "Reporting & Analyse vom Podcast",
      "Persönliche Betreuung (via Whatsapp, Mail & Telefon)",
      "1:1 Quartals/Feedbackgespräch",
      "Uploadservice & Hosting auf allen relevanten Kanälen",
      "Erstellung von Titel, Shownotes & Verlinkungen",
      "Kostenfreies Hosting über unseren Podigee Hosting-Service",
    ],
    ctaText: "Audio + Hosting Anfragen",
    note: "*Preise in Netto",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "premium-podcast",
    showCalculator: true,
    packageType: "audio-pro-hosting",
  },
];

export const videoPlans: PricingPlan[] = [
  {
    id: "video-basic",
    title: "Video Basic",
    subtitle: "Der perfekte Start für deinen Video-Podcast",
    price: 0, // Will be set dynamically
    features: [
      "Ideal für klassische Video-Remote-Podcasts",
      "Qualität, die man hört und sieht",
      "Spare Zeit und Nerven",
    ],
    bulletPoints: [
      "Schnitt, Mischung, Sound-Design & Mastering von Audio und Video",
      "Inkl. Feedbackschleife",
      "Social Assets pro Episode (Audio Snippet, VideoReel/Beitrag)",
      "1:1 Quartals & Feedbackgespräch",
      "A/B Schnitt",
    ],
    ctaText: "Video Basic Anfragen",
    note: "*Preise in Netto",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "classic-video",
    showCalculator: true,
    packageType: "video-basic",
  },
  {
    id: "video-pro",
    title: "Video Pro",
    subtitle: "Stark im Bild - stark im Ton",
    price: 0, // Will be set dynamically
    features: [
      "Die Beste Wahl für ein visuell starken Podcast",
      "Bild & Ton in Perfektion",
      "Weil Qualität Vertrauen schafft",
    ],
    bulletPoints: [
      "Schnitt, Mischung, Sound-Design sowie Mastering von Audio & Video",
      "inkl. Feedbackschleife",
      "Social Assets pro Episode (Audio Snippet, VideoReel/Beitrag)",
      "1:1 Quartals & Feedbackgespräch",
      "Mehrkamera Schnitt + Motion Design + Color Grading",
      "Preisvorteil beim Podigee-Hosting",
    ],
    ctaText: "Video Pro Anfragen",
    note: "*Preise in Netto",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "all-in-one-video",
    isHighlighted: true,
    showCalculator: true,
    packageType: "video-pro",
  },
  {
    id: "video-hosting",
    title: "Video + Hosting",
    subtitle: "Das beste Full-Service Paket",
    price: 0, // Will be set dynamically
    features: [
      "Für diejenigen, die ihren Podcast-Workflow in professionelle Hände legen wollen",
      "Wir übernehmen Produktion, Hosting und Veröffentlichung",
      "Alles, was dein Podcast braucht",
    ],
    bulletPoints: [
      "Schnitt, Mischung, Sound-Design & Mastering von Audio und Video",
      "Inkl. Feedbackschleife",
      "Social Assets pro Episode (Audio Snippet, Reel/Beitrag)",
      "Persönliche Betreuung (via Whatsapp, Mail & Telefon)",
      "1:1 Quartals & Feedbackgespräch",
      "Mehrkamera Schnitt + Motion Design + Color Grading",
      "Erstellung von Titel, Shownotes & Verlinkungen",
      "Uploadservice & Hosting auf allen relevanten Kanälen",
      "Inkl. kostenloses Hosting bei Podigee",
    ],
    ctaText: "Video + Hosting Anfragen",
    note: "*Preise in Netto",
    ctaLink: "https://calendly.com/voiceart-productions/erstgespraech",
    buttonId: "premium-video",
    showCalculator: true,
    packageType: "video-pro-hosting",
  },
];
